import Promise from 'bluebird';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { FetchDataResponseType } from '@bingads-webui-fluent-component/entity-selector';

import { FetchDataResponseTypeExtend, FetchGoalFactoryParams } from './types';
import { generateGoalFilter } from './utils';

export const getPaginationData = (page: number, pageSize: number) => ({
  top: pageSize,
  skip: (page - 1) * pageSize,
  count: true,
});

export const mapGoalsToItems = goals => goals.map(goal => ({
  value: String(goal.Id),
  content: goal.Name,
  data: goal,
}));

const fetchConversionGoals = (cid : string, aid : string, dataQuery: any) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Goals['Default.GetConversionGoals']
  .$makeCall({
    query: {
      ...dataQuery,
    },
  })
  .toPromise();

export const fetchConversionGoalFactory =
  ({
    cid, aid, options = {}, goalIds = [],
  }: FetchGoalFactoryParams) => ({
    page, pageSize, search, sortState,
  }): Promise<(FetchDataResponseType & FetchDataResponseTypeExtend)> => {
    const select = ['Id', 'Name', 'GoalCategory', 'Status', 'TrackingStatus', 'Type', 'IsMainConversionGoal', 'GoalDiagnosticsInfo'];

    let filter = '(Status eq Enum.GoalStatus\'Active\') and ((GoalCategory eq Enum.GoalCategory\'InStoreVisit\') eq false)';

    if (options.filter) {
      filter += options.filter;
    }

    if (search && search !== '') {
      filter += ` and (contains(tolower(Name), '${search.toLowerCase()}'))`;
    }

    if (goalIds.length > 0) {
      filter = `(${filter}) or (${generateGoalFilter(goalIds, search)})`;
    }

    const defaultOrder = { IsMainConversionGoal: 0 };
    const orderby = (sortState && sortState.sortColumn) ? { [sortState.sortColumn]: sortState.sortDirection === 'ascending' ? 0 : 1 } : defaultOrder;
    const dataQuery = {
      top: pageSize,
      skip: (page - 1) * pageSize,
      filter: { where: filter },
      orderby,
      count: true,
      select,
    };

    return fetchConversionGoals(cid, aid, dataQuery).then(({ '@odata.count': count, value: goals }) => ({
      items: mapGoalsToItems(goals),
      currentPage: page,
      count,
      totalPages: Math.ceil(count / pageSize),
    }));
  };
